import {  Create_CONTACT } from "../type";
import { InsertData } from "../../Hooks/InsertData";
export const CreateContacthelpAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(`/api/ContactUs/ContactUs`, data);
    dispatch({
      type: Create_CONTACT,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Create_CONTACT,
      payload: "Error" + e,
    });
  }
};
